import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Menu, MenuItems } from '../../../shared/menu-items/menu-items';
import { Router } from '@angular/router';
import { DynamicDrawerService } from 'app/shared/dynamic-drawer.service';
import { DropdownService } from 'app/dropdowns/dropdown.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: [`
    .sidebar-container {
      display: flex;
      flex-direction: column;
    }
  `]
})

export class AppSidebarComponent implements OnDestroy {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  status: boolean = true;
  itemSelect: number[] = [];
  parentIndex: Number;
  childIndex: Number;
  sideIconWithText: boolean = false;

  setClickedRow(i, j) {
    this.parentIndex = i;
    this.childIndex = j;
  }

  subclickEvent() {
    this.status = true;
  }

  scrollToTop() {
    document.querySelector('.page-wrapper').scroll({
      top: 0,
      left: 0
    });
  }

  constructor(
    private readonly router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private readonly drawerService: DynamicDrawerService<null>,
    public readonly menuItems: MenuItems,
    private readonly dropdownService: DropdownService) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(){}

  logOut() {
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  onIconWithText(value: string) {
    if (value === 'Data Source') {
      this.sideIconWithText = !this.sideIconWithText;
    }

    this.drawerService._subMenuHandle.next(this.sideIconWithText);
  }

  openDropdownList(){
    this.router.navigate(['/dropdowns']);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

}